import { render, staticRenderFns } from "./CraftLink.vue?vue&type=template&id=30296aa0"
import script from "./CraftLink.vue?vue&type=script&lang=js"
export * from "./CraftLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports